import { Controller } from "@hotwired/stimulus";
import $ from "jquery";
import "datatables.net-bs5";
import "datatables.net-responsive-bs5";
import "datatables.net-buttons-bs5";

export default class extends Controller {
  static targets = [
    "projectFilter",
    "classFilter",
    "statusFilter",
    "priceMinFilter",
    "priceMaxFilter",
    "sizeMinFilter",
    "sizeMaxFilter",
    "saleValueMinFilter",
    "saleValueMaxFilter"
  ];

  connect() {
    const tableElement = $(this.element).find("#properties-table");

    this.dataTable = tableElement.DataTable({
      pageLength: 10,
      lengthMenu: [5, 10, 25, 50],
      order: [[1, "asc"]],
      dom:
        "<'row mb-3'<'col-sm-2'l><'col-sm-6 text-end'B>>" +
        "<'row mb-3'<'col-sm-6'f>>" +
        "<'row'<'col-12'tr>>" +
        "<'row mt-3'<'col-sm-5'i><'col-sm-7'p>>",
      buttons: [
        { extend: "excelHtml5", className: "btn btn-outline-success btn-sm me-2 rounded-pill", text: "Excel" },
        { extend: "csvHtml5", className: "btn btn-outline-primary btn-sm me-2 rounded-pill", text: "CSV" },
        { extend: "print", className: "btn btn-outline-secondary btn-sm rounded-pill", text: "Print" }
      ],
      language: { searchPlaceholder: "Type to Search...", search: "" }
    });

    // Custom filtering
    $.fn.dataTable.ext.search.push((settings, data, dataIndex) => {
      if (settings.nTable !== tableElement[0]) return true;

      const project = this.projectFilterTarget.value;
      const category = this.classFilterTarget.value;
      const status = this.statusFilterTarget.value.toLowerCase();

      const priceMin = parseFloat(this.priceMinFilterTarget.value);
      const priceMax = parseFloat(this.priceMaxFilterTarget.value);

      const sizeMin = parseFloat(this.sizeMinFilterTarget.value);
      const sizeMax = parseFloat(this.sizeMaxFilterTarget.value);

      const saleMin = parseFloat(this.saleValueMinFilterTarget.value);
      const saleMax = parseFloat(this.saleValueMaxFilterTarget.value);

      const rowProject = data[2];
      const rowCategory = data[3];
      const rowSize = parseFloat(data[4]) || 0;
      const rowPrice = parseFloat(data[5].replace(/[^0-9.-]+/g,"")) || 0;
      const rowSale = parseFloat(data[6].replace(/[^0-9.-]+/g,"")) || 0;
      const rowStatus = data[7].toLowerCase().trim();

      if (project && rowProject !== project) return false;
      if (category && rowCategory !== category) return false;
      if (status && rowStatus !== status) return false;
      if (!isNaN(priceMin) && rowPrice < priceMin) return false;
      if (!isNaN(priceMax) && rowPrice > priceMax) return false;
      if (!isNaN(sizeMin) && rowSize < sizeMin) return false;
      if (!isNaN(sizeMax) && rowSize > sizeMax) return false;
      if (!isNaN(saleMin) && rowSale < saleMin) return false;
      if (!isNaN(saleMax) && rowSale > saleMax) return false;

      return true;
    });

    // Refilter on change
    [
      this.projectFilterTarget,
      this.classFilterTarget,
      this.statusFilterTarget,
      this.priceMinFilterTarget,
      this.priceMaxFilterTarget,
      this.sizeMinFilterTarget,
      this.sizeMaxFilterTarget,
      this.saleValueMinFilterTarget,
      this.saleValueMaxFilterTarget
    ].forEach(el => el.addEventListener("input", () => this.refresh()));
  }

  refresh() {
    this.dataTable.draw();
  }

  clearFilters() {
    [
      this.projectFilterTarget,
      this.classFilterTarget,
      this.statusFilterTarget,
      this.priceMinFilterTarget,
      this.priceMaxFilterTarget,
      this.sizeMinFilterTarget,
      this.sizeMaxFilterTarget,
      this.saleValueMinFilterTarget,
      this.saleValueMaxFilterTarget
    ].forEach(el => el.value = "");

    this.dataTable.search("").draw();
    this.dataTable.draw();
  }
}
